import React, { Component } from 'react';
import Group from 'components/mix/Group.js';
import NewGroup from 'components/mix/NewGroup.js';

class GroupsComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            renders: 0,
        };
    }

    onDraggingTrack(track) {
        this.setState({
            trackDragging: track,
            renders: this.state.renders+2
        });
    }

    // Forces renders everywhere (used for drag and drop)
    // TODO: use a better way to determine when state has changed in a way
    // where there should be a re-render
    onGroupsChanged() {
        this.setState({renders: this.state.renders+2});
    }


    get groups() {
        return this.props.sequencerEngine.groups;
    }

    render() {
        return (
            <div className="groups-component">
               {this.groups.groups.map(
                       group =>
                           <Group
                                 sequencerEngine={this.props.sequencerEngine}
                                 trackDragging={this.state.trackDragging}
                                 renders={this.state.renders}
                                 onGroupsChanged={() => this.onGroupsChanged()}
                                 cursor={this.props.sequencerEngine.cursor}
                                 groups={this.groups}
                                 onDraggingTrack={(track) => this.onDraggingTrack(track)}
                                 pattern={this.props.sequencerEngine.currentPattern}
                                 channelMixer={this.props.sequencerEngine.channelMixer}
                             group={group}/>)}
                   <NewGroup
                     onGroupsChanged={() => this.onGroupsChanged()}
                     groups={this.groups}
                     trackDragging={this.state.trackDragging}
                   />
            </div>
        );
    }
}

export default GroupsComponent;
